import 'consumerweb-shim';
import React from 'react';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';

import Charity from '../../charityMobile';

import * as ViewActions from '../actions/Actions';
import * as analytics from '../../../lib/analytics';

import content from '../../../lib/i18n';
const i18n = content('multiCharityFundraiser/components/CharityMobile');

const CharityContainer = props => {
  const handleCharityClick = (selectedIndex, source, npid) => {
    props.dispatch(ViewActions.selectedCharity(selectedIndex, source));

    analytics.trackLinkWithData(
      'charity',
      props.fptiInfo.pgrp,
      props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  };

  const handleInfoClick = (selectedIndexCharityInfo, source, charityResponse) => {
    analytics.trackLinkWithData(
      'infoIcon',
      props.fptiInfo.pgrp,
      props.fptiInfo.page,
      { crid: charityResponse && charityResponse.nonprofit_id },
      'link'
    );
  };

  const handleDefaultCharityState = source => {
    props.dispatch(ViewActions.defaultState(source));
  };

  const handlePopOverClose = source => {
    props.dispatch(ViewActions.defaultPopoverState(source));
  };

  const handleSeeMore = source => {
    props.dispatch(ViewActions.expandSeeMore(source));
  };

  let npoBaseUrl = `/fundraiser/${props.campaignId}/charity/`;
  return (
    <div>
      <Charity
        onHandleClick={handleCharityClick}
        onInfoClick={handleInfoClick}
        onPopoverClose={handlePopOverClose}
        onHandleDefaultCharityState={handleDefaultCharityState}
        handleSeeMore={handleSeeMore}
        charityModuleTitleDefault={i18n('title.charity-module-title')}
        charityModuleChooseAmountTextDefault={i18n(
          'title.charity-module-choose-amount'
        )}
        npoBaseUrl={npoBaseUrl}
        source='featured'
        {...props}
      />
    </div>
  );
};

export default connect(state => ({
  // connects reducer with component
  csrf: state.server.csrf,
  data: state.server.data,
  coBrand: state.server.coBrand,
  charityResponse: state.charity.featured.charityResponse,
  selectedCharity: state.charity.featured.selectedCharity,
  selectedIndex: state.charity.featured.selectedIndex,
  selectedIndexCharityInfo: state.charity.featured.selectedIndexCharityInfo,
  charityModuleTitle:
    state.server.templateData.donationModule &&
    state.server.templateData.donationModule.header,
  charityModuleSubHeader:
    state.server.templateData.donationModule &&
    state.server.templateData.donationModule.subHeader,
  charityModuleChooseAmountText:
    state.server.templateData.donationModule &&
    state.server.templateData.donationModule.chooseAmountText,
  clickedRadioBtn: state.charity.featured.clickedRadioBtn,
  charities: state.server.data.charities,
  amounts: state.server.data.amounts,
  campaignId: state.server.campaignId,
  campaignState: state.server.data.state,
}))(CharityContainer);
